<template>
  <v-dialog
    :value="value"
    @input="$emit('input', false)"
    transition="slide-x-transition"
    max-width="90vw"
    persistent
    scrollable
  >
    <v-card class="custom-text custom-blue">
      <v-card-title class="custom-text font-weight-semibold headline ubuntu">
        Select your student
        <v-spacer></v-spacer>
        <v-btn color="#29284c" icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <app-pagination :getter="getStudents" :params="params" autoCard header>
          <template #card="{ item }">
            <app-student-card :item="item" :action="action" :disable="disable">
              <template #buttonText>
                <slot name="buttonText"></slot>
              </template>
            </app-student-card>
          </template>
        </app-pagination>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Pagination from "./Pagination.vue";
import StudentCard from "./StudentCard.vue";

import { getStudents } from "@/api/api";
export default {
  components: {
    appPagination: Pagination,
    appStudentCard: StudentCard,
  },
  props: {
    value: {
      required: false,
      default: false,
      type: Boolean,
    },
    action: {
      required: true,
      type: Function,
    },
    disable: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      getStudents,
      search: "",
      params: { limit: 10, is_active: true },
    };
  },
  created() {
    if (!this.$route.path.includes("/admin/")) {
      this.params.teachers__uuid = this.$store.getters.profile.uuid;
    }
  },
};
</script>
<style scoped>
.ubuntu {
  font-family: Ubuntu !important;
}
.bordered {
  border: 1px solid lightgray;
}
.v-avatar {
  border: 1px solid #29274d;
}
.custom-blue {
  background: #f8fcff 0% 0% no-repeat padding-box !important;
}
</style>
